import { BrowserRouter, Routes, Route } from 'react-router-dom';

import './App.css';
import { HOME, SIGN_IN, SIGN_UP, FORGOTTEN_PASSWORD, NEW_PASSWORD, SERIES, ID, CONFIRM, MY_ACCOUNT, STATS } from 'config/url';

import Home from 'containers/Home';
import SignIn from 'containers/SignIn';
import SignUp from 'containers/SignUp';
import PasswordForgotten from 'containers/PasswordForgotten';
import NewPassword from 'containers/NewPassword';
import Confirmation from 'containers/Confirmation';
import Series from 'containers/Series';
import Serie from 'containers/Serie';
import Stats from 'containers/Stats';
import Result from 'containers/Result';
import Account from 'containers/Account';

import useUser from 'hooks/useUser';


function App() {
  const user = useUser();
  const navbarProps = {
    logged_in: user.isAuthenticated
  };
  return (
  <BrowserRouter>
    <Routes>
      <Route path={HOME} element={<Home navbarProps={navbarProps}/>} />
      <Route path={SIGN_IN} element={<SignIn navbarProps={navbarProps}/>} />
      <Route path={SIGN_UP} element={<SignUp navbarProps={navbarProps}/>} />
      <Route path={FORGOTTEN_PASSWORD} element={<PasswordForgotten navbarProps={navbarProps} />} />
      <Route path={NEW_PASSWORD} element={<NewPassword navbarProps={navbarProps} />} />
      <Route path={CONFIRM} element={<Confirmation navbarProps={navbarProps}/>} />
      <Route path={STATS}>
        <Route index element={<Stats navbarProps={navbarProps}/>} />
        <Route path={ID} element={<Result navbarProps={navbarProps} />} />
      </Route>
      <Route path={MY_ACCOUNT} element={<Account navbarProps={navbarProps}/>} />
      <Route path={SERIES}>
        <Route index element={<Series navbarProps={navbarProps} />}/>
        <Route path={ID} element={<Serie navbarProps={navbarProps} />} />
      </Route>
    </Routes>
  </BrowserRouter>
  );
}

export default App;
